import { Paper, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useListContext } from "react-admin";
import { useContext } from "react";

import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    [theme.breakpoints.down("sm")]: {
      width: 100,
    },
    paddingTop: 10,
    width: 120,
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 0,
    zIndex: 999,
    overflowX: "hidden" /* Hide horizontal scrollbar */,
    overflowY: "scroll" /* Add vertical scrollbar */,
    "&::-webkit-scrollbar": {
      width: "0.05em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 3px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 3px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ff7f50",
      outline: "1px solid orange",
    },
  },
  button: {
    width: 101,
    height: 98,
    minHeight: 98,
    maxHeight: 98,
    marginTop: 20,
    borderRadius: 20,
  },
  highlight: {
    backgroundColor: "#FA9917",
  },
  normal: {
    backgroundColor: theme.layout.nonSelected.backgroundColor,
  },
}));

const ProductTypeBar = ({
  selectedCatIndex: catIndex,
  setSelectedCatIndex: setSelectedIndex,
}) => {
  let items = [];
  const { setFilters, filterValues } = useListContext();

  const classes = useStyles();

  const [state] = useContext(PaymentCreateContext);

  items = state.productType;
  const buttonList = items.map((item, index) => {
    if (index === catIndex) {
      return (
        <CategoryButton
          label={item.name}
          selected
          onClick={() => setFilters({})}
        />
      );
    } else
      return (
        <CategoryButton
          label={item.name}
          onClick={() => {
            if (item.id === "-1") {
              setFilters({});
              setSelectedIndex(index);
            } else {
              setSelectedIndex(index);
              setFilters({ ...filterValues, category_id: item.id });
            }
            return;
          }}
        />
      );
  });

  return (
    <Paper className={classes.allContainer} scrollable>
      {buttonList}
    </Paper>
  );
};

const CategoryButton = ({ label, selected, onClick, index }) => {
  const classes = useStyles();
  return (
    <Button
      key={index}
      className={
        selected
          ? `${classes.button} ${classes.highlight}`
          : `${classes.button} ${classes.normal}`
      }
      onClick={onClick}
      variant="contained"
      color="primary"
    >
      <Typography
        fontWeight="fontWeightBold"
        display="initial"
        color="textPrimary"
        noWrap
      >
        {label}
      </Typography>
    </Button>
  );
};

export default ProductTypeBar;
